const NEW_FEELGREAT_HOST = 'u-feelgreat.unicity.com'

export const getNewFeelGreatMarketUrl = (country, referralCode, search = '', hash = '') => {
    const liveUrl = String(country?.live || '').replace(/\{{2,3}\s*language\s*\}{2,3}/g, '')

    if (!liveUrl.startsWith('https://') || !referralCode) return ''

    const targetUrl = new URL(liveUrl)
    if (targetUrl.hostname !== NEW_FEELGREAT_HOST) return ''

    targetUrl.pathname = `${targetUrl.pathname.replace(/\/$/, '')}/${referralCode}`
    targetUrl.search = search
    targetUrl.hash = hash

    return targetUrl.toString()
}

export const getNewFeelGreatRedirectUrl = (location, country) => {
    if (location.hostname !== 'fg.unicity.com') return ''

    const [, referralCode] = location.pathname.split('/').filter(Boolean)
    return getNewFeelGreatMarketUrl(country, referralCode, location.search, location.hash)
}
